<template>
  <div>
    <div class="rj-page-card">
      <div class="rj-page-card__content">
        <el-form ref="searchForm" :inline="true" class="" :model="searchForm">
          <el-form-item label="业务实体:" prop="bussinessEntity">
            <el-select
              v-model="searchForm.bussinessEntity"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="option in businessEntity"
                :key="option.dictValue"
                :label="option.dictLabel"
                :value="option.dictValue"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="收款编号:" prop="telegraphicTransferNum" clearable>
            <el-input v-model.trim="searchForm.telegraphicTransferNum" placeholder="请输入收款编号" />
          </el-form-item>
          <el-form-item label="收款日期:" prop="arrivalMoneyStartDate">
            <div class="rj-flex">
              <div class="rj-flex__item">
                <el-date-picker
                  v-model="searchForm.arrivalMoneyStartDate"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                  clearable
                />
              </div>
              <div style="display: inline-block;width: 10px;text-align: center">
                -
              </div>
              <div class="rj-flex__item">
                <el-date-picker
                  v-model="searchForm.arrivalMoneyEndDate"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                  :picker-options="pickerOptions"
                  clearable
                />
              </div>
            </div>
          </el-form-item>
          <el-form-item label="银行名称:" prop="accountCompany">
            <el-select
              v-model="searchForm.accountCompany"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="option in bankName"
                :key="option.dictValue"
                :label="option.dictLabel"
                :value="option.dictValue"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="原始客户名称:" prop="importCompany" clearable>
            <el-input v-model.trim="searchForm.importCompany" placeholder="请输入原始客户名称" />
          </el-form-item>
          <el-form-item label="修改后客户名称:" prop="newImportCompany" clearable>
            <el-input v-model.trim="searchForm.newImportCompany" placeholder="请输入修改后客户名称" />
          </el-form-item>
          <el-form-item label="收款单已生成:" prop="isReceipt">
            <el-select
              v-model="searchForm.isReceipt"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="option in generatedVoucher"
                :key="option.dictValue"
                :label="option.dictLabel"
                :value="option.dictValue"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="已分配:" prop="isAssigned">
            <el-select
              v-model="searchForm.isAssigned"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="option in allocated"
                :key="option.dictValue"
                :label="option.dictLabel"
                :value="option.dictValue"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="申请日期:" prop="startTime">
            <div class="rj-flex">
              <div class="rj-flex__item">
                <el-date-picker
                  v-model="searchForm.startTime"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                  clearable
                />
              </div>
              <div style="display: inline-block;width: 10px;text-align: center">
                -
              </div>
              <div class="rj-flex__item">
                <el-date-picker
                  v-model="searchForm.endTime"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                  :picker-options="pickerOptions"
                  clearable
                />
              </div>
            </div>
          </el-form-item>
          <el-button type="primary" :loading="isLoading" @click="doSearch">
            查询
          </el-button>
          <el-button type="default" @click="resetForm">
            重置
          </el-button>
          <!-- <el-button type="primary">导出资金认领详细</el-button> -->
        </el-form>
      </div>
    </div>
    <el-table v-loading="isLoading" :data="tableData" border style="width: 100%">
      <el-table-column label="操作" align="left" fixed="left" width="80">
        <template v-slot="{row}">
          <el-button type="text" @click="check(row)">
            查看
          </el-button>
        </template>
      </el-table-column>
      <el-table-column prop="bussinessEntity" label="业务实体" align="left" />
      <el-table-column prop="accountCompany" label="银行名称" align="left" />
      <el-table-column prop="remittanceDate" label="收款日期" align="left" />
      <el-table-column prop="telegraphicTransferNum" label="收款编号" align="left">
        <template v-slot="{row}">
          <el-button type="text" class="el-btn-text-left" @click="showInfo(row.telegraphicTransferNum)">
            {{ row.telegraphicTransferNum }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column prop="remittanceAmount" label="净收款额(元)" align="right" header-align="left" width="100px" />
      <el-table-column prop="serviceFee" label="手续费(元)" align="right" header-align="left" />
      <el-table-column prop="importCompany" label="原始客户名称" align="left" width="120px" />
      <el-table-column prop="newImportCompany" label="修改后客户名称" align="left" width="120px" />
      <el-table-column prop="isAssigned" label="是否已分配" align="left" width="120px">
        <template v-slot="{row}">
          <span v-if="row.isAssigned">是</span>
          <span v-else>否</span>
        </template>
      </el-table-column>
      <el-table-column prop="summary" label="来款摘要" align="left" />
      <el-table-column prop="isReceipt" label="是否已生成收款单" align="left" width="120px">
        <template v-slot="{row}">
          <span v-if="row.isReceipt">是</span>
          <span v-else>否</span>
        </template>
      </el-table-column>
      <el-table-column prop="collectionCategories" label="收款大类" align="left" />
      <el-table-column prop="isDelete" label="是否已废弃" align="left">
        <template v-slot="{row}">
          <span v-if="row.isDelete">是</span>
          <span v-else>否</span>
        </template>
      </el-table-column>
      <el-table-column prop="rebuild" label="作废类型" align="left">
        <template v-slot="{row}">
          <span v-if="row.rebuild">委托付款</span>
          <span v-else>认款主档错误</span>
        </template>
      </el-table-column>
      <el-table-column prop="applicationName" label="申请人" align="left" />
      <el-table-column prop="applicationTime" label="申请时间" align="left" />
    </el-table>
    <div style="text-align: right;margin-top: 10px">
      <el-pagination
        :page-sizes="[10, 20, 30, 40]"
        :page-size.sync="page.pageSize"
        :current-page.sync="page.currentPage"
        layout="total, prev, pager, next, jumper,sizes"
        :total="page.total"
        hide-on-single-page
        @size-change="handerSizeChange"
        @current-change="handerCurrentChange"
      />
    </div>
    <!-- TODO -->
    <!-- 分页 -->
    <el-dialog v-if="remittanceVisible" title="国内电汇详细信息" :visible.sync="remittanceVisible" width="800px">
      <remittance-info-box :id="telegraphicTransferNum" />
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="remittanceVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
    <el-dialog v-if="getErrVisible" title="来款错误查看" :visible.sync="getErrVisible" width="800px">
      <checkDetail :id="aid" />
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="getErrVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import remittanceInfoBox from '../../components/remittanceInfoBox';
import checkDetail from './checkDetail';
import { getDictData, checkedList } from '@/API';
export default {
  components: {
    remittanceInfoBox,
    checkDetail
  },
  data () {
    return {
      cancellationVisible: false,
      searchForm: {
        bussinessEntity: '',
        telegraphicTransferNum: '',
        arrivalMoneyStartDate: '',
        arrivalMoneyEndDate: '',
        accountCompany: '',
        importCompany: '',
        newImportCompany: '',
        isReceipt: '',
        isAssigned: '',
        startTime: '',
        endTime: ''
      },
      page: {
        pageSize: 10,
        total: 100,
        currentPage: 1
      },
      pickerOptions: {
        disabledDate: (time) => {
          if (this.searchForm.arrivalMoneyStartDate) {
            let date = new Date(this.searchForm.arrivalMoneyStartDate);
            date.setDate(date.getDate() - 1);
            return time.getTime() <= date.getTime();
          }
          return false;
        }
      },
      isLoading: false,
      tableData: [],
      remittanceVisible: false,
      remittanceInfoID: '', // 电汇底单编号
      changeName: false, // 修改客户名称
      editName: false,
      businessEntity: [],
      bankName: [],
      generatedVoucher: [],
      allocated: [],
      changeData: {},
      isLoadingChangeSure: false,
      isLoadingEditSure: false,
      telegraphicTransferNum: '',
      getErrVisible: false,
      aid: ''
    };
  },
  computed: {},
  mounted () {
    this.initData();
  },
  methods: {
    initData () {
      let parmas = ['business_entity', 'bank_name', 'generated_voucher', 'allocated'];
      getDictData(parmas).then((res) => {
        const json = res.data;
        if (json.status === '200') {
          // 下拉列表基础数据
          json.data.forEach((item) => {
            if (item.dictType === 'business_entity') {
              this.businessEntity = item.dictDataVOS;
            }
            if (item.dictType === 'bank_name') {
              this.bankName = item.dictDataVOS;
            }
            if (item.dictType === 'generated_voucher') {
              this.generatedVoucher = item.dictDataVOS;
            }
            if (item.dictType === 'allocated') {
              this.allocated = item.dictDataVOS;
            }
          });
        }
      }).catch((err) => {
        console.log(err);
      });
      this.doSearch();
    },
    doSearch () {
      this.isLoading = true;
      checkedList({
        ...this.searchForm,
        pageIndex: this.page.currentPage,
        pageSize: this.page.pageSize
      }).then((res) => {
        this.isLoading = false;
        let json = res.data;
        if (json.status === '200') {
          this.tableData = json.data.list;
          this.page.total = json.data.total;
        } else {
          this.tableData = [];
          this.page.currentPage = 1;
          this.page.total = 0;
        }
      }).catch(() => {
        this.isLoading = false;
      });
    },
    resetForm () {
      this.$refs.searchForm.resetFields();
      this.page.currentPage = 1;
      this.searchForm.arrivalMoneyEndDate = '';
      this.doSearch();
    },
    showInfo (val) {
      this.telegraphicTransferNum = val;
      this.remittanceVisible = true;
    },
    check (row) {
      this.aid = row.aid;
      this.getErrVisible = true;
    },
    handerSizeChange (val) {
      // 改变每页条数 当前页回到第一页
      this.page.currentPage = 1;
      this.doSearch();
    },
    handerCurrentChange (val) {
      // 改变当前页
      this.page.currentPage = val;
      this.doSearch();
    }
  }
};
</script>

<style>

</style>
